import {
  AI_AGENT_LABELS,
  formatLabel,
  formatModelLabel,
  formatScopePaths,
  type SelectedAiModel
} from './workflowShared';

interface ScanSummaryProps {
  orderedSelectedSkills: string[];
  orderedSelectedAiModels: SelectedAiModel[];
  target: string;
  branch: string;
  scopePaths: string[];
  selectionLabel?: string;
  targetLabel?: string;
  branchLabel?: string;
  scopeLabel?: string;
  showBranch?: boolean;
  showScope?: boolean;
}

function ScanSummary({
  orderedSelectedSkills,
  orderedSelectedAiModels,
  target,
  branch,
  scopePaths,
  selectionLabel = 'Skill packs',
  targetLabel = 'Repository',
  branchLabel = 'Branch',
  scopeLabel = 'Scope',
  showBranch = true,
  showScope = true
}: ScanSummaryProps) {
  return (
    <aside className="scan-summary" aria-label="Scan summary">
      <h2>Scan summary</h2>
      <dl>
        <div>
          <dt>{selectionLabel}</dt>
          <dd>{orderedSelectedSkills.length || 'None selected'}</dd>
        </div>
        <div>
          <dt>{targetLabel}</dt>
          <dd>{target.trim() || 'Not set'}</dd>
        </div>
        {showBranch && (
          <div>
            <dt>{branchLabel}</dt>
            <dd>{branch.trim() || 'Not set'}</dd>
          </div>
        )}
        {showScope && (
          <div>
            <dt>{scopeLabel}</dt>
            <dd>{formatScopePaths(scopePaths)}</dd>
          </div>
        )}
      </dl>

      {orderedSelectedAiModels.length > 0 && (
        <div className="scan-summary-tags">
          {orderedSelectedAiModels.map(({ agent, model }) => (
            <span key={`${agent}-${model}`}>
              {formatLabel(agent, AI_AGENT_LABELS)} / {formatModelLabel(model)}
            </span>
          ))}
        </div>
      )}
    </aside>
  );
}

export default ScanSummary;
